import React from "react";
import { BRAND } from "@/lib/brand";

const SIZES = {
    sm: { box: "h-9 w-9 text-lg", name: "text-lg" },
    md: { box: "h-10 w-10 text-xl", name: "text-xl" },
};

export default function BrandMark({ size = "sm", subtitle = BRAND.tagline, label = BRAND.name }) {
    const s = SIZES[size] || SIZES.sm;
    return (
        <div className="flex items-center gap-2" data-testid="brand-mark">
            <div
                className={`${s.box} rounded-xl bg-gradient-to-br from-indigo-500 via-cyan-400 to-emerald-400 flex items-center justify-center text-slate-950 font-black`}
                aria-hidden="true"
            >
                R
            </div>
            <div>
                <div className={`font-extrabold tracking-tight text-slate-100 ${s.name} leading-none`}>
                    {label}
                </div>
                {subtitle && <div className="label-eyebrow mt-1">{subtitle}</div>}
            </div>
        </div>
    );
}
